/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CommonDetails } from '../models/common-details';
import { DeviceTypeDto } from '../models/device-type-dto';

@Injectable({
  providedIn: 'root',
})
export class DeviceTypeControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation findAllDeviceTypes
   */
  static readonly FindAllDeviceTypesPath = '/api/v1/devicetype';

  /**
   * GET All DeviceTypes.
   *
   * The api fetches all the Available deviceTypes
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAllDeviceTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAllDeviceTypes$Response(params?: {
    active?: string;
  }): Observable<StrictHttpResponse<Array<DeviceTypeDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceTypeControllerService.FindAllDeviceTypesPath, 'get');
    if (params) {
      rb.query('active', params.active, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DeviceTypeDto>>;
      })
    );
  }

  /**
   * GET All DeviceTypes.
   *
   * The api fetches all the Available deviceTypes
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findAllDeviceTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAllDeviceTypes(params?: {
    active?: string;
  }): Observable<Array<DeviceTypeDto>> {

    return this.findAllDeviceTypes$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DeviceTypeDto>>) => r.body as Array<DeviceTypeDto>)
    );
  }

  /**
   * Path part for operation createDeviceType
   */
  static readonly CreateDeviceTypePath = '/api/v1/devicetype';

  /**
   * Create a new DeviceType.
   *
   * The api creates a new DeviceType
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createDeviceType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDeviceType$Response(params?: {
    body?: DeviceTypeDto
  }): Observable<StrictHttpResponse<DeviceTypeDto>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceTypeControllerService.CreateDeviceTypePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DeviceTypeDto>;
      })
    );
  }

  /**
   * Create a new DeviceType.
   *
   * The api creates a new DeviceType
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createDeviceType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDeviceType(params?: {
    body?: DeviceTypeDto
  }): Observable<DeviceTypeDto> {

    return this.createDeviceType$Response(params).pipe(
      map((r: StrictHttpResponse<DeviceTypeDto>) => r.body as DeviceTypeDto)
    );
  }

  /**
   * Path part for operation findAllDeviceTypesBasedOnSolutionType
   */
  static readonly FindAllDeviceTypesBasedOnSolutionTypePath = '/api/v1/solutiontype/{id}/devicetype';

  /**
   * GET All DeviceTypes.
   *
   * The api fetches all the Available deviceTypes
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAllDeviceTypesBasedOnSolutionType()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAllDeviceTypesBasedOnSolutionType$Response(params: {
    id: string;
    profileId?: string;
    deviceInterfaceProviderId?: string;
    devicePropertiesReqd?: string;
    active?: string;
  }): Observable<StrictHttpResponse<Array<DeviceTypeDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceTypeControllerService.FindAllDeviceTypesBasedOnSolutionTypePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('profileId', params.profileId, {});
      rb.query('deviceInterfaceProviderId', params.deviceInterfaceProviderId, {});
      rb.query('devicePropertiesReqd', params.devicePropertiesReqd, {});
      rb.query('active', params.active, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DeviceTypeDto>>;
      })
    );
  }

  /**
   * GET All DeviceTypes.
   *
   * The api fetches all the Available deviceTypes
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findAllDeviceTypesBasedOnSolutionType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAllDeviceTypesBasedOnSolutionType(params: {
    id: string;
    profileId?: string;
    deviceInterfaceProviderId?: string;
    devicePropertiesReqd?: string;
    active?: string;
  }): Observable<Array<DeviceTypeDto>> {

    return this.findAllDeviceTypesBasedOnSolutionType$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DeviceTypeDto>>) => r.body as Array<DeviceTypeDto>)
    );
  }

  /**
   * Path part for operation findByDeviceTypeId
   */
  static readonly FindByDeviceTypeIdPath = '/api/v1/devicetype/{id}';

  /**
   * GET specific DeviceType.
   *
   * The api fetches the specific DeviceType for the given Id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByDeviceTypeId()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByDeviceTypeId$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<DeviceTypeDto>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceTypeControllerService.FindByDeviceTypeIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DeviceTypeDto>;
      })
    );
  }

  /**
   * GET specific DeviceType.
   *
   * The api fetches the specific DeviceType for the given Id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findByDeviceTypeId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByDeviceTypeId(params: {
    id: string;
  }): Observable<DeviceTypeDto> {

    return this.findByDeviceTypeId$Response(params).pipe(
      map((r: StrictHttpResponse<DeviceTypeDto>) => r.body as DeviceTypeDto)
    );
  }

  /**
   * Path part for operation updateDeviceType
   */
  static readonly UpdateDeviceTypePath = '/api/v1/devicetype/{id}';

  /**
   * Update DeviceType.
   *
   * The api updates the specific DeviceType for the given Id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateDeviceType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDeviceType$Response(params: {
    id: string;
    body?: DeviceTypeDto
  }): Observable<StrictHttpResponse<DeviceTypeDto>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceTypeControllerService.UpdateDeviceTypePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DeviceTypeDto>;
      })
    );
  }

  /**
   * Update DeviceType.
   *
   * The api updates the specific DeviceType for the given Id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateDeviceType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDeviceType(params: {
    id: string;
    body?: DeviceTypeDto
  }): Observable<DeviceTypeDto> {

    return this.updateDeviceType$Response(params).pipe(
      map((r: StrictHttpResponse<DeviceTypeDto>) => r.body as DeviceTypeDto)
    );
  }

  /**
   * Path part for operation activateDeviceType
   */
  static readonly ActivateDeviceTypePath = '/api/v1/devicetype/{id}/activate';

  /**
   * Activate DeviceType.
   *
   * The api activates the specific DeviceType for the given Id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `activateDeviceType()` instead.
   *
   * This method doesn't expect any request body.
   */
  activateDeviceType$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceTypeControllerService.ActivateDeviceTypePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
       responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Activate DeviceType.
   *
   * The api activates the specific DeviceType for the given Id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `activateDeviceType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  activateDeviceType(params: {
    id: string;
  }): Observable<void> {

    return this.activateDeviceType$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation deactivateDeviceType
   */
  static readonly DeactivateDeviceTypePath = '/api/v1/devicetype/{id}/deactivate';

  /**
   * Deactivate DeviceType.
   *
   * The api deactivates the specific DeviceType for the given Id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deactivateDeviceType()` instead.
   *
   * This method doesn't expect any request body.
   */
  deactivateDeviceType$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceTypeControllerService.DeactivateDeviceTypePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
       responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Deactivate DeviceType.
   *
   * The api deactivates the specific DeviceType for the given Id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deactivateDeviceType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deactivateDeviceType(params: {
    id: string;
  }): Observable<void> {

    return this.deactivateDeviceType$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation findDeviceTypeDetailsById
   */
  static readonly FindDeviceTypeDetailsByIdPath = '/api/v1/devicetypebasic/{id}';

  /**
   * GET  DeviceType By id.
   *
   * The api fetches the Available deviceType by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findDeviceTypeDetailsById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findDeviceTypeDetailsById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<CommonDetails>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceTypeControllerService.FindDeviceTypeDetailsByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CommonDetails>;
      })
    );
  }

  /**
   * GET  DeviceType By id.
   *
   * The api fetches the Available deviceType by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findDeviceTypeDetailsById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findDeviceTypeDetailsById(params: {
    id: string;
  }): Observable<CommonDetails> {

    return this.findDeviceTypeDetailsById$Response(params).pipe(
      map((r: StrictHttpResponse<CommonDetails>) => r.body as CommonDetails)
    );
  }

  /**
   * Path part for operation syncDeviceTypesWithSubscription
   */
  static readonly SyncDeviceTypesWithSubscriptionPath = '/api/v1/solDevIntfProv/{solDevIntfProvId}/subscription/{subscriptionId}/devicetype';

  /**
   * create exiting DeviceTypes in new subscription.
   *
   * The api syncs exiting DeviceTypes with new subscription
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `syncDeviceTypesWithSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  syncDeviceTypesWithSubscription$Response(params: {
    solDevIntfProvId: string;
    subscriptionId: string;
  }): Observable<StrictHttpResponse<'100 CONTINUE' | '101 SWITCHING_PROTOCOLS' | '102 PROCESSING' | '103 CHECKPOINT' | '200 OK' | '201 CREATED' | '202 ACCEPTED' | '203 NON_AUTHORITATIVE_INFORMATION' | '204 NO_CONTENT' | '205 RESET_CONTENT' | '206 PARTIAL_CONTENT' | '207 MULTI_STATUS' | '208 ALREADY_REPORTED' | '226 IM_USED' | '300 MULTIPLE_CHOICES' | '301 MOVED_PERMANENTLY' | '302 FOUND' | '302 MOVED_TEMPORARILY' | '303 SEE_OTHER' | '304 NOT_MODIFIED' | '305 USE_PROXY' | '307 TEMPORARY_REDIRECT' | '308 PERMANENT_REDIRECT' | '400 BAD_REQUEST' | '401 UNAUTHORIZED' | '402 PAYMENT_REQUIRED' | '403 FORBIDDEN' | '404 NOT_FOUND' | '405 METHOD_NOT_ALLOWED' | '406 NOT_ACCEPTABLE' | '407 PROXY_AUTHENTICATION_REQUIRED' | '408 REQUEST_TIMEOUT' | '409 CONFLICT' | '410 GONE' | '411 LENGTH_REQUIRED' | '412 PRECONDITION_FAILED' | '413 PAYLOAD_TOO_LARGE' | '413 REQUEST_ENTITY_TOO_LARGE' | '414 URI_TOO_LONG' | '414 REQUEST_URI_TOO_LONG' | '415 UNSUPPORTED_MEDIA_TYPE' | '416 REQUESTED_RANGE_NOT_SATISFIABLE' | '417 EXPECTATION_FAILED' | '418 I_AM_A_TEAPOT' | '419 INSUFFICIENT_SPACE_ON_RESOURCE' | '420 METHOD_FAILURE' | '421 DESTINATION_LOCKED' | '422 UNPROCESSABLE_ENTITY' | '423 LOCKED' | '424 FAILED_DEPENDENCY' | '425 TOO_EARLY' | '426 UPGRADE_REQUIRED' | '428 PRECONDITION_REQUIRED' | '429 TOO_MANY_REQUESTS' | '431 REQUEST_HEADER_FIELDS_TOO_LARGE' | '451 UNAVAILABLE_FOR_LEGAL_REASONS' | '500 INTERNAL_SERVER_ERROR' | '501 NOT_IMPLEMENTED' | '502 BAD_GATEWAY' | '503 SERVICE_UNAVAILABLE' | '504 GATEWAY_TIMEOUT' | '505 HTTP_VERSION_NOT_SUPPORTED' | '506 VARIANT_ALSO_NEGOTIATES' | '507 INSUFFICIENT_STORAGE' | '508 LOOP_DETECTED' | '509 BANDWIDTH_LIMIT_EXCEEDED' | '510 NOT_EXTENDED' | '511 NETWORK_AUTHENTICATION_REQUIRED'>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceTypeControllerService.SyncDeviceTypesWithSubscriptionPath, 'post');
    if (params) {
      rb.path('solDevIntfProvId', params.solDevIntfProvId, {});
      rb.path('subscriptionId', params.subscriptionId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<'100 CONTINUE' | '101 SWITCHING_PROTOCOLS' | '102 PROCESSING' | '103 CHECKPOINT' | '200 OK' | '201 CREATED' | '202 ACCEPTED' | '203 NON_AUTHORITATIVE_INFORMATION' | '204 NO_CONTENT' | '205 RESET_CONTENT' | '206 PARTIAL_CONTENT' | '207 MULTI_STATUS' | '208 ALREADY_REPORTED' | '226 IM_USED' | '300 MULTIPLE_CHOICES' | '301 MOVED_PERMANENTLY' | '302 FOUND' | '302 MOVED_TEMPORARILY' | '303 SEE_OTHER' | '304 NOT_MODIFIED' | '305 USE_PROXY' | '307 TEMPORARY_REDIRECT' | '308 PERMANENT_REDIRECT' | '400 BAD_REQUEST' | '401 UNAUTHORIZED' | '402 PAYMENT_REQUIRED' | '403 FORBIDDEN' | '404 NOT_FOUND' | '405 METHOD_NOT_ALLOWED' | '406 NOT_ACCEPTABLE' | '407 PROXY_AUTHENTICATION_REQUIRED' | '408 REQUEST_TIMEOUT' | '409 CONFLICT' | '410 GONE' | '411 LENGTH_REQUIRED' | '412 PRECONDITION_FAILED' | '413 PAYLOAD_TOO_LARGE' | '413 REQUEST_ENTITY_TOO_LARGE' | '414 URI_TOO_LONG' | '414 REQUEST_URI_TOO_LONG' | '415 UNSUPPORTED_MEDIA_TYPE' | '416 REQUESTED_RANGE_NOT_SATISFIABLE' | '417 EXPECTATION_FAILED' | '418 I_AM_A_TEAPOT' | '419 INSUFFICIENT_SPACE_ON_RESOURCE' | '420 METHOD_FAILURE' | '421 DESTINATION_LOCKED' | '422 UNPROCESSABLE_ENTITY' | '423 LOCKED' | '424 FAILED_DEPENDENCY' | '425 TOO_EARLY' | '426 UPGRADE_REQUIRED' | '428 PRECONDITION_REQUIRED' | '429 TOO_MANY_REQUESTS' | '431 REQUEST_HEADER_FIELDS_TOO_LARGE' | '451 UNAVAILABLE_FOR_LEGAL_REASONS' | '500 INTERNAL_SERVER_ERROR' | '501 NOT_IMPLEMENTED' | '502 BAD_GATEWAY' | '503 SERVICE_UNAVAILABLE' | '504 GATEWAY_TIMEOUT' | '505 HTTP_VERSION_NOT_SUPPORTED' | '506 VARIANT_ALSO_NEGOTIATES' | '507 INSUFFICIENT_STORAGE' | '508 LOOP_DETECTED' | '509 BANDWIDTH_LIMIT_EXCEEDED' | '510 NOT_EXTENDED' | '511 NETWORK_AUTHENTICATION_REQUIRED'>;
      })
    );
  }

  /**
   * create exiting DeviceTypes in new subscription.
   *
   * The api syncs exiting DeviceTypes with new subscription
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `syncDeviceTypesWithSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  syncDeviceTypesWithSubscription(params: {
    solDevIntfProvId: string;
    subscriptionId: string;
  }): Observable<'100 CONTINUE' | '101 SWITCHING_PROTOCOLS' | '102 PROCESSING' | '103 CHECKPOINT' | '200 OK' | '201 CREATED' | '202 ACCEPTED' | '203 NON_AUTHORITATIVE_INFORMATION' | '204 NO_CONTENT' | '205 RESET_CONTENT' | '206 PARTIAL_CONTENT' | '207 MULTI_STATUS' | '208 ALREADY_REPORTED' | '226 IM_USED' | '300 MULTIPLE_CHOICES' | '301 MOVED_PERMANENTLY' | '302 FOUND' | '302 MOVED_TEMPORARILY' | '303 SEE_OTHER' | '304 NOT_MODIFIED' | '305 USE_PROXY' | '307 TEMPORARY_REDIRECT' | '308 PERMANENT_REDIRECT' | '400 BAD_REQUEST' | '401 UNAUTHORIZED' | '402 PAYMENT_REQUIRED' | '403 FORBIDDEN' | '404 NOT_FOUND' | '405 METHOD_NOT_ALLOWED' | '406 NOT_ACCEPTABLE' | '407 PROXY_AUTHENTICATION_REQUIRED' | '408 REQUEST_TIMEOUT' | '409 CONFLICT' | '410 GONE' | '411 LENGTH_REQUIRED' | '412 PRECONDITION_FAILED' | '413 PAYLOAD_TOO_LARGE' | '413 REQUEST_ENTITY_TOO_LARGE' | '414 URI_TOO_LONG' | '414 REQUEST_URI_TOO_LONG' | '415 UNSUPPORTED_MEDIA_TYPE' | '416 REQUESTED_RANGE_NOT_SATISFIABLE' | '417 EXPECTATION_FAILED' | '418 I_AM_A_TEAPOT' | '419 INSUFFICIENT_SPACE_ON_RESOURCE' | '420 METHOD_FAILURE' | '421 DESTINATION_LOCKED' | '422 UNPROCESSABLE_ENTITY' | '423 LOCKED' | '424 FAILED_DEPENDENCY' | '425 TOO_EARLY' | '426 UPGRADE_REQUIRED' | '428 PRECONDITION_REQUIRED' | '429 TOO_MANY_REQUESTS' | '431 REQUEST_HEADER_FIELDS_TOO_LARGE' | '451 UNAVAILABLE_FOR_LEGAL_REASONS' | '500 INTERNAL_SERVER_ERROR' | '501 NOT_IMPLEMENTED' | '502 BAD_GATEWAY' | '503 SERVICE_UNAVAILABLE' | '504 GATEWAY_TIMEOUT' | '505 HTTP_VERSION_NOT_SUPPORTED' | '506 VARIANT_ALSO_NEGOTIATES' | '507 INSUFFICIENT_STORAGE' | '508 LOOP_DETECTED' | '509 BANDWIDTH_LIMIT_EXCEEDED' | '510 NOT_EXTENDED' | '511 NETWORK_AUTHENTICATION_REQUIRED'> {

    return this.syncDeviceTypesWithSubscription$Response(params).pipe(
      map((r: StrictHttpResponse<'100 CONTINUE' | '101 SWITCHING_PROTOCOLS' | '102 PROCESSING' | '103 CHECKPOINT' | '200 OK' | '201 CREATED' | '202 ACCEPTED' | '203 NON_AUTHORITATIVE_INFORMATION' | '204 NO_CONTENT' | '205 RESET_CONTENT' | '206 PARTIAL_CONTENT' | '207 MULTI_STATUS' | '208 ALREADY_REPORTED' | '226 IM_USED' | '300 MULTIPLE_CHOICES' | '301 MOVED_PERMANENTLY' | '302 FOUND' | '302 MOVED_TEMPORARILY' | '303 SEE_OTHER' | '304 NOT_MODIFIED' | '305 USE_PROXY' | '307 TEMPORARY_REDIRECT' | '308 PERMANENT_REDIRECT' | '400 BAD_REQUEST' | '401 UNAUTHORIZED' | '402 PAYMENT_REQUIRED' | '403 FORBIDDEN' | '404 NOT_FOUND' | '405 METHOD_NOT_ALLOWED' | '406 NOT_ACCEPTABLE' | '407 PROXY_AUTHENTICATION_REQUIRED' | '408 REQUEST_TIMEOUT' | '409 CONFLICT' | '410 GONE' | '411 LENGTH_REQUIRED' | '412 PRECONDITION_FAILED' | '413 PAYLOAD_TOO_LARGE' | '413 REQUEST_ENTITY_TOO_LARGE' | '414 URI_TOO_LONG' | '414 REQUEST_URI_TOO_LONG' | '415 UNSUPPORTED_MEDIA_TYPE' | '416 REQUESTED_RANGE_NOT_SATISFIABLE' | '417 EXPECTATION_FAILED' | '418 I_AM_A_TEAPOT' | '419 INSUFFICIENT_SPACE_ON_RESOURCE' | '420 METHOD_FAILURE' | '421 DESTINATION_LOCKED' | '422 UNPROCESSABLE_ENTITY' | '423 LOCKED' | '424 FAILED_DEPENDENCY' | '425 TOO_EARLY' | '426 UPGRADE_REQUIRED' | '428 PRECONDITION_REQUIRED' | '429 TOO_MANY_REQUESTS' | '431 REQUEST_HEADER_FIELDS_TOO_LARGE' | '451 UNAVAILABLE_FOR_LEGAL_REASONS' | '500 INTERNAL_SERVER_ERROR' | '501 NOT_IMPLEMENTED' | '502 BAD_GATEWAY' | '503 SERVICE_UNAVAILABLE' | '504 GATEWAY_TIMEOUT' | '505 HTTP_VERSION_NOT_SUPPORTED' | '506 VARIANT_ALSO_NEGOTIATES' | '507 INSUFFICIENT_STORAGE' | '508 LOOP_DETECTED' | '509 BANDWIDTH_LIMIT_EXCEEDED' | '510 NOT_EXTENDED' | '511 NETWORK_AUTHENTICATION_REQUIRED'>) => r.body as '100 CONTINUE' | '101 SWITCHING_PROTOCOLS' | '102 PROCESSING' | '103 CHECKPOINT' | '200 OK' | '201 CREATED' | '202 ACCEPTED' | '203 NON_AUTHORITATIVE_INFORMATION' | '204 NO_CONTENT' | '205 RESET_CONTENT' | '206 PARTIAL_CONTENT' | '207 MULTI_STATUS' | '208 ALREADY_REPORTED' | '226 IM_USED' | '300 MULTIPLE_CHOICES' | '301 MOVED_PERMANENTLY' | '302 FOUND' | '302 MOVED_TEMPORARILY' | '303 SEE_OTHER' | '304 NOT_MODIFIED' | '305 USE_PROXY' | '307 TEMPORARY_REDIRECT' | '308 PERMANENT_REDIRECT' | '400 BAD_REQUEST' | '401 UNAUTHORIZED' | '402 PAYMENT_REQUIRED' | '403 FORBIDDEN' | '404 NOT_FOUND' | '405 METHOD_NOT_ALLOWED' | '406 NOT_ACCEPTABLE' | '407 PROXY_AUTHENTICATION_REQUIRED' | '408 REQUEST_TIMEOUT' | '409 CONFLICT' | '410 GONE' | '411 LENGTH_REQUIRED' | '412 PRECONDITION_FAILED' | '413 PAYLOAD_TOO_LARGE' | '413 REQUEST_ENTITY_TOO_LARGE' | '414 URI_TOO_LONG' | '414 REQUEST_URI_TOO_LONG' | '415 UNSUPPORTED_MEDIA_TYPE' | '416 REQUESTED_RANGE_NOT_SATISFIABLE' | '417 EXPECTATION_FAILED' | '418 I_AM_A_TEAPOT' | '419 INSUFFICIENT_SPACE_ON_RESOURCE' | '420 METHOD_FAILURE' | '421 DESTINATION_LOCKED' | '422 UNPROCESSABLE_ENTITY' | '423 LOCKED' | '424 FAILED_DEPENDENCY' | '425 TOO_EARLY' | '426 UPGRADE_REQUIRED' | '428 PRECONDITION_REQUIRED' | '429 TOO_MANY_REQUESTS' | '431 REQUEST_HEADER_FIELDS_TOO_LARGE' | '451 UNAVAILABLE_FOR_LEGAL_REASONS' | '500 INTERNAL_SERVER_ERROR' | '501 NOT_IMPLEMENTED' | '502 BAD_GATEWAY' | '503 SERVICE_UNAVAILABLE' | '504 GATEWAY_TIMEOUT' | '505 HTTP_VERSION_NOT_SUPPORTED' | '506 VARIANT_ALSO_NEGOTIATES' | '507 INSUFFICIENT_STORAGE' | '508 LOOP_DETECTED' | '509 BANDWIDTH_LIMIT_EXCEEDED' | '510 NOT_EXTENDED' | '511 NETWORK_AUTHENTICATION_REQUIRED')
    );
  }

}
